import React from 'react';
import { motion } from 'framer-motion';
import { Package, ShieldCheck, Zap, Users } from 'lucide-react';
import { db, collection, getDocs } from '@/firebase';

export default function HomeStats() {
  const [productCount, setProductCount] = React.useState(0);
  const [userCount, setUserCount] = React.useState(0);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchStats = async () => {
      try {
        const productsSnapshot = await getDocs(collection(db, 'products'));
        setProductCount(productsSnapshot.size || 0);
        
        // const usersSnapshot = await getDocs(collection(db, 'users')); // Blocked by security rules
        // setUserCount(usersSnapshot.size || 0);
        setUserCount(500); // Mock value for now
      } catch (error) {
        console.error('Error fetching stats:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const stats = [
    { label: 'Katalog Produk', value: productCount > 0 ? `${productCount}+` : '6+', icon: Package, color: 'text-purple-600', bg: 'bg-purple-50' },
    { label: 'Layanan Cepat', value: 'Instant', icon: Zap, color: 'text-primary', bg: 'bg-gold/10' },
    { label: 'Keamanan Data', value: '100%', icon: ShieldCheck, color: 'text-green-600', bg: 'bg-green-50' },
    { label: 'Client Puas', value: userCount > 0 ? `${userCount}+` : '500+', icon: Users, color: 'text-blue-600', bg: 'bg-blue-50' },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-6 sm:-mt-10 relative z-20">
      <div className="bg-card/80 backdrop-blur-xl rounded-[2rem] p-3 sm:p-5 shadow-2xl shadow-foreground/10 border border-border">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-6">
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="flex items-center gap-3 sm:gap-4 px-4 py-2 sm:py-3 rounded-2xl hover:bg-foreground/[0.02] transition-all group"
            >
              <div className={`h-10 w-10 sm:h-14 sm:w-14 bg-gradient-to-br from-background to-[${stat.bg.replace('bg-', '')}]/50 rounded-xl sm:rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300 shadow-sm border border-border/50 ring-2 ring-transparent group-hover:ring-border/50`}>
                <stat.icon strokeWidth={1.5} className={`h-5 w-5 sm:h-7 sm:w-7 ${stat.color} filter drop-shadow-sm`} />
              </div>
              <div className="min-w-0">
                <p className="text-[8px] sm:text-[10px] text-foreground/40 font-bold uppercase tracking-wider leading-none mb-1">{stat.label}</p>
                <div className="flex items-baseline gap-1">
                  <p className="text-sm sm:text-xl font-black text-foreground truncate leading-none">
                    {loading ? '...' : stat.value}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
